module.exports = __webpack_public_path__ + "static/media/check-box.b1e05710.svg";